import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../core';
import { Dashboards } from '../../features/dashboards/Dashboards';

export const DashboardsPage = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Dashboards'
  })
)(Dashboards);
